import React from "react";
import styled from "styled-components";

const Button = ({
  onClick,
  children,
  color,
  variant,
  icon,
  className,
  noBorder,
  size = "medium",
  ...props
}) => {
  const allClassNames = [
    color,
    variant,
    className,
    noBorder && "no-border",
    size,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <StyledButton className={allClassNames} onClick={onClick} {...props}>
      {icon}
      {children}
    </StyledButton>
  );
};

const StyledButton = styled.button`
  border-radius: var(--radius-container);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 1px solid var(--menu-active-color);
  background-color: transparent;
  color: var(--text-color);

  &.small {
    font-size: 13px;
    padding: 10px 16px;
  }

  &.medium {
    padding: 8px 25px;
  }

  &.no-border {
    border: none !important;
  }

  &.contained {
    color: var(--white);

    &.primary {
      background-color: var(--blue);
    }

    &.danger {
      background-color: var(--red-color);
    }

    &.warning {
      background-color: var(--orange);
    }

    &.success {
      background-color: var(--green-color);
    }
  }

  &.outlined {
    background-color: transparent;

    &.primary {
      color: var(--blue);
      border: 1px solid var(--blue);
    }

    &.danger {
      color: var(--red-color);
      border: 1px solid var(--red-color);
    }

    &.warning {
      color: var(--orange);
      border: 1px solid var(--orange);
    }

    &.success {
      color: var(--green-color);
      border: 1px solid var(--green-color);
    }
  }

  &.transparent {
    background-blend-mode: lighten;
    &.primary {
      background-color: rgba(39, 75, 151, 0.2);
      color: var(--blue);
      border: 1px solid var(--blue);
    }

    &.danger {
      background-color: rgba(224, 49, 55, 0.2);
      color: var(--red-color);
      border: 1px solid var(--red-color);
    }

    &.warning {
      background-color: rgba(234, 94, 35, , 0.2);
      color: var(--orange);
      border: 1px solid var(--orange);
    }

    &.success {
      background-color: rgba(39, 163, 118, 0.2);
      color: var(--green-color);
      border: 1px solid var(--green-color);
    }
  }
`;

export default Button;
